import { theme } from '@prophecy/theme';
export const tokens = {
    StyledProgressBarContainer: {
        width: theme.width.x320,
        height: theme.sizes.x20
    },
    ProgressBar: {
        height: theme.sizes.x8,
        width: theme.width.x320,
        Content: {
            backgroundColor: theme.colors.gray200,
            transition: theme.transition.m
        },
        loading: {
            backgroundColor: theme.colors.brand500
        },
        success: {
            backgroundColor: theme.colors.success500
        },
        error: {
            backgroundColor: theme.colors.error500
        },
        size: {
            borderRadius: theme.radius.x8
        }
    },
    label: {
        color: theme.colors.gray700,
        fontSize: theme.text.sm.fontSize,
        fontWeight: theme.fontWeight.normal
    }
};
